// import parseTime, formatTime and set to filter
export { parseTime, formatTime } from '@/utils';

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: 'E' },
    { value: 1e15, symbol: 'P' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'G' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' }
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value)
          .toFixed(digits)
          .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
      );
    }
  }
  return num.toString();
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * @deprecated 格式化 -时间 70 ->  1分20秒
 *
 */
export function formatDuration(string) {
  const sec = string % 60;
  const minutes = Math.floor(string / 60);
  if (minutes > 0) {
    return `${minutes}分${sec}秒`;
  }
  return `${sec}秒`;
}

// 金额拼接大写
export function amountToUpperCase(money) {
  // 定义大写数字和单位
  var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']; // 数字大写
  var cnIntRadice = ['', '拾', '佰', '仟']; // 基本单位
  var cnIntUnits = ['', '万', '亿', '兆']; // 大单位
  var cnDecUnits = ['角', '分']; // 小数单位
  var cnInteger = '整'; // 整数部分结尾
  var cnIntLast = '元'; // 整数部分单位
  var maxNum = 999999999999999.99; // 最大处理数字
  // 校验输入
  if (money === '' || isNaN(money)) {
    return '请输入有效数字';
  }
  if (money > maxNum) {
    return '超出最大处理范围';
  }
  if (money == 0) {
    return 0;
  }
  var decimalNum = money.toString().split('.')[1] || '00' // 小数部分（保留两位）
  // 转换为浮点数，分离整数和小数部分
  money = parseFloat(money);
  var integerNum = Math.floor(money); // 整数部分
  var chineseStr = ''; // 输出的中文金额字符串
  // 处理整数部分
  chineseStr += handleInteger(integerNum, cnNums, cnIntRadice, cnIntUnits, cnIntLast);
  // 处理小数部分
  if (decimalNum!=='00') {
    chineseStr += handleDecimal(decimalNum, cnNums, cnDecUnits, cnInteger);
  } else {
    chineseStr += cnInteger
  }
  return chineseStr;
}
// 处理整数部分
function handleInteger(integerNum, cnNums, cnIntRadice, cnIntUnits, cnIntLast) {
  if (integerNum === 0) return ''; // 整数部分为零直接跳过
  var integerStr = '';
  var zeroCount = 0; // 用于记录连续零的个数
  var intStr = integerNum.toString();

  for (var i = 0; i < intStr.length; i++) {
    var n = intStr.charAt(i); // 当前数字
    var p = intStr.length - i - 1; // 对应位数
    var q = Math.floor(p / 4); // 大单位索引
    var m = p % 4; // 小单位索引

    if (n === '0') {
      zeroCount++;
    } else {
      if (zeroCount > 0) {
        integerStr += cnNums[0];
      }
      zeroCount = 0; // 重置零计数
      integerStr += cnNums[parseInt(n)] + cnIntRadice[m];
    }
    if (m === 0 && zeroCount < 4) {
      integerStr += cnIntUnits[q];
    }
  }
  return integerStr + cnIntLast;
}

// 处理小数部分
function handleDecimal(decimalNum, cnNums, cnDecUnits, cnInteger) {
  if (decimalNum == 0) return ''; // 小数部分为零返回空字符串

  var decimalStr = '';
  var decStr = (decimalNum).toString();

  // 处理角
  if (decStr.length > 0 && decStr.charAt(0) !== '0') {
    decimalStr += cnNums[parseInt(decStr.charAt(0))] + cnDecUnits[0];
  } else {
    decimalStr += cnNums[parseInt(decStr.charAt(0))]
  }
  // 处理分
  if (decStr.length > 1 && decStr.charAt(1) !== '0') {
    decimalStr += cnNums[parseInt(decStr.charAt(1))] + cnDecUnits[1];
  }
  return decimalStr || cnInteger; // 如果没有分，返回“整”
}
